import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ExternalCourseDetailsSidebar from "../components/ExternalCourseCmponents/ExternalCourseDetailsSidebar/ExternalCourseDetailsSidebar";
import ExternalCourseDetailsSectionContent from "../components/ExternalCourseCmponents/ExternalCourseDetailsSectionContent/ExternalCourseDetailsSectionContent";
import { UserContext } from "../context/user";
import axios from "axios";
import { getURLs } from "../urlConfig";
import CustomModal from "../components/CustomModal/CustomModal";
import { enrollInCourse } from "../utils/network-requests";

const ExternalCourseDetails = () => {
  const {
    state: { userInfo },
  } = useContext(UserContext);

  const navigate = useNavigate();
  const [courseData, setCourseData] = useState({});
  const [enrollButtonText, setEnrollButtonText] = useState("Enroll");
  const { courseId } = useParams();

  const [expanded, setExpanded] = useState("");
  const [sectionContent, setSectionContent] = useState({});

  const [loading, setLoading] = useState(true);
  const [errorLoading, setErrorLoading] = useState(false);

  const handleCourseEnroll = () => {
    if (
      parseFloat(courseData?.cost || 0) === undefined ||
      parseFloat(courseData?.cost || 0) <= 0 ||
      parseFloat(courseData?.cost || 0) - (courseData?.discount || 0) <= 0
    ) {
      const studentInfo = {
        name: userInfo?.name,
        email: userInfo?.email,
        image: userInfo?.profileImage,
        country: "India",
      };
      enrollInCourse(
        userInfo?.authToken,
        courseData?._id,
        studentInfo,
        courseData?.author_id
      )
        .then(() => {
          setEnrollButtonText("Enrolled");
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      navigate(`/course/checkout`, {
        state: {
          courseData,
        },
      });
    }
  };

  useEffect(() => {
    if (Object.keys(userInfo || {}).length > 0) {
      setLoading(true);
      // fetch course information from course id
      axios
        .get(getURLs("book-info"), {
          headers: {
            "auth-token": userInfo.authToken,
          },
          params: { bookSlug: courseId },
        })
        .then((response) => {
          const bookInfo = response.data?.bookDetails;
          setCourseData(bookInfo);
          setExpanded(bookInfo?.grades[0]?.chapters?.[0]?._id);
          setSectionContent(
            bookInfo?.grades[0]?.chapters?.[0]?.headings[0]?.topics[0]
          );
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setErrorLoading(true);
          setLoading(false);
        });
    }
  }, [userInfo, courseId]);

  useEffect(() => {
    if (
      Object.keys(userInfo || {}).length > 0 &&
      Object.keys(courseData).length > 0
    ) {
      axios
        .get(getURLs("is-enrolled"), {
          params: {
            courseId: courseData?._id,
          },
          headers: {
            "auth-token": userInfo?.authToken,
          },
          withCredentials: true,
        })
        .then((res) => {
          if (res.data?.isEnrolledInCourse) {
            setEnrollButtonText("Enrolled");
          } else {
            setEnrollButtonText("Enroll");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [courseData, userInfo]);

  return (
    <div className="bg-gray21 dark:bg-darkBgColor1 px-4 py-4">
      {!loading && !errorLoading ? (
        <>
          <div className="flex items-center justify-end mb-2">
            <button
              className="flex items-center px-5 py-2 font-urbanist font-semibold text-white text-sm border-none rounded-xl"
              style={{
                background:
                  "linear-gradient(90deg, rgba(79, 172, 254, 0.6) 0%, rgba(0, 242, 254, 0.6) 100%), #2898FF",
              }}
              onClick={
                enrollButtonText?.toLowerCase() === "enrolled"
                  ? () => {}
                  : handleCourseEnroll
              }
            >
              {enrollButtonText}
            </button>
          </div>
          <div className="bg-white dark:bg-darkBgColor1 py-2 flex flex-col-reverse lg:flex-row items-start border border-gray-100 dark:border-purple2 rounded-3xl">
            {/* course content table */}
            <div className="lg:basis-1/4 w-full px-2">
              <ExternalCourseDetailsSidebar
                expanded={expanded}
                setExpanded={setExpanded}
                courseData={courseData}
                sectionContent={sectionContent}
                setSectionContent={setSectionContent}
              />
            </div>

            {/* selected tab content */}
            <ExternalCourseDetailsSectionContent
              courseData={courseData}
              sectionContent={sectionContent}
            />
          </div>
        </>
      ) : !loading && errorLoading ? (
        <CustomModal show={!loading && errorLoading} centered>
          {!loading && errorLoading && (
            <div className="px-10 py-8 rounded-md bg-white dark:bg-purple14 dark:border dark:border-purple26">
              <p className="font-urbanist font-medium text-gray-600 dark:text-white">
                Failed to load the course, please refresh the page
              </p>
            </div>
          )}
        </CustomModal>
      ) : (
        <CustomModal show={loading} centered>
          {loading && (
            <div className="px-10 py-8 rounded-md bg-white dark:bg-purple14 dark:border dark:border-purple26">
              <p className="font-urbanist font-medium text-gray-600 dark:text-white">
                Please wait, loading course details
              </p>
            </div>
          )}
        </CustomModal>
      )}
    </div>
  );
};

export default ExternalCourseDetails;
